import { getLessonBySubCourseId as fetchLessonBySubCourseId } from "../../mp-database"

export const getLessonBySubCourseId = sub_course_id => {
  return fetchLessonBySubCourseId(sub_course_id).then(querySnapshot => {
    let result = []
    querySnapshot.forEach(doc => {
      let data = doc.data
      if (!data.deleted) {
        result.push(data)
      }
    })
    return result
  })
}
